import { createFileRoute } from '@tanstack/react-router';
import Strategy from './-Strategy';

export const Route = createFileRoute('/(strategy)/$issuerId/$portfolioID')({
  component: Strategy,
});
